import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import styles from './BackToMerchantButton.module.scss'

type BackToMerchantButtonProps = {
  returnUrl?: string
  className?: string
}

export const BackToMerchantButton = ({ returnUrl, className }: BackToMerchantButtonProps) => {
  return returnUrl ? (
    <div className={cn(styles['back-to-merchant-button'], className)}>
      <a href={returnUrl} target='_top'>
        &larr; {tr('CHECKOUT.PAYMENT.BACK_TO_MERCHANT', 'Back to merchant')}
      </a>
    </div>
  ) : null
}
